import dynamic from "next/dynamic";

export const FullScreenMobileImageDisplay = dynamic(
  () => import("./FullScreenMobileImageDisplaySsr").then((mod) => mod.FullScreenMobileImageDisplaySsr),
  { ssr: false }
);
